module.exports = __webpack_public_path__ + "static/dickies-9932d9e04bd829eedf6df7ccf739449d.jpg";